import { getReducedLocations } from '#component/map/helper';
import { compareMetric } from '#helper';

function getGeoJSON(data) {
  const features = [];

  const devices = data.reduce((a, c) => {
    if (c.locationsChunks) {
      c.locationsChunks.forEach(locations => {
        a.push({ ...c, locations });
      });
    } else {
      a.push(c);
    }

    return a;
  }, []);

  devices.forEach((d, i) => {
    const { projectAlertId } = d;
    const alertSetting = projectAlertId ? d.alerts.find(a => a.id === projectAlertId) : null;
    const { tMin, tMax, hMin, hMax, bMin } = alertSetting || {};
    const locations = getReducedLocations(d, 0.3);
    // .map(l => ([l.lng, l.lat]));
    locations.forEach((l, n) => {
      const nl = locations[n + 1];
      if (nl) {
        let tempExcursion = 0;
        let humiExcursion = 0;
        let batExcursion = 0;
        if (alertSetting && l.metrics) {
          if (typeof (tMin ?? tMax) === 'number') {
            const value = l.metrics.temp_probe ?? l.metrics.temp ?? l.metrics.t_in;
            const valueNext = nl.metrics.temp_probe ?? nl.metrics.temp ?? nl.metrics.t_in;
            tempExcursion =
              Number(compareMetric(tMin, tMax, value) && compareMetric(tMin, tMax, valueNext));
          }
          if (typeof (hMin ?? hMax) === 'number') {
            humiExcursion =
              Number(
                compareMetric(hMin, hMax, l.metrics.humi) &&
                compareMetric(hMin, hMax, nl.metrics.humi)
              );
          }
          if (typeof bMin === 'number') {
            batExcursion =
              Number(
                compareMetric(bMin, null, l.metrics.bat) &&
                compareMetric(bMin, null, nl.metrics.bat)
              );
          }
        }
        features.push({
          type: 'Feature',
          properties: {
            uid: d.uid,
            color: d.color,
            index: i,
            tempExcursion,
            humiExcursion,
            batExcursion
          },
          geometry: {
            type: 'LineString',
            coordinates: [[l.lng, l.lat], [locations[n + 1].lng, locations[n + 1].lat]]
          }
        });
      }
    });
  });

  return {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features
    }
  };
}

export default {
  addLayer(map) {
    this.map = map;
    const { devices } = map.app;

    map.addLayer({
      id: 'lines',
      source: 'routes',
      type: 'line',
      paint: {
        'line-width': 2,
        'line-color': [
          'case',
          ['any', ['>=', ['get', 'tempExcursion'], 1], ['>=', ['get', 'humiExcursion'], 1]],
          '#f44336',
          '#5eb676'
        ]
      }
    });
    const interpolate = [
      'interpolate',
      ['linear'],
      ['get', 'index']
    ];
    if (devices.length) {
      devices.forEach((d, i) => interpolate.push(i, ['literal', [0, i <= 4 ? i * 10 : i % 5]]));
    } else {
      interpolate.push(0, ['literal', [0, 0]]);
    }

    map.addLayer({
      id: 'directions',
      type: 'symbol',
      source: 'routes',
      paint: {
        'icon-color': ['concat', '#', ['get', 'color']]
      },
      layout: {
        'symbol-placement': 'line',
        'symbol-spacing': 80,
        'icon-image': 'navigation',
        'icon-rotate': 90,
        'icon-offset': interpolate,
        'icon-rotation-alignment': 'map',
        'icon-ignore-placement': true
      }
    });
  },
  getGeoJSON
};
